import { ScheduleItem } from "../../../global-data/types/schedule-item";

import './test-list.scss'

interface ScheduleProps {
    data: ScheduleItem
  }
  
  export function ShowSchedule(props: ScheduleProps) {
    return (
      <div className="container schedule-grid">
        <div className="schedule-title fs-5 fw-bold">
          {props.data.title}
        </div>
        <div className="schedule-subtitle fs-5">
          {props.data.subtitle}
        </div>
        <div className="schedule-description fs-5">
          {props.data.text}
        </div>
      </div>
    )
  }
  